export const granteeBudgetCategoryFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Name: 'name',
  FGM_Portal__Parent_Category__c: 'parentCategory',
  Order__c: 'order'
}

export interface GranteeBudgetCategory {
  id: string
  name: string
  parentCategory: string | null
  order: number | null
}

interface CategoryData {
  id: string
  order: number
}
export interface GranteeBudgetCategoryMap {
  en_CA: {
    revenues: Record<string, CategoryData>
    expenses: Record<string, CategoryData>
  }
  fr_CA: {
    revenues: Record<string, CategoryData>
    expenses: Record<string, CategoryData>
  }
}

export const granteeBudgetCategoryMapping = {
  Expenses: { lang: 'en_CA', category: 'expenses' },
  Revenue: { lang: 'en_CA', category: 'revenues' },
  Dépenses: { lang: 'fr_CA', category: 'expenses' },
  Revenu: { lang: 'fr_CA', category: 'revenues' }
}
